import { useEffect, useState } from "react";
import {
  CircularProgress,
  Box,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { darkColors } from "../../theme/colors";
import { assetIcons } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import AccountSidebar from "./account-sidebar";
import { useNavigate } from "react-router-dom";
import routes from "../../constants/routes";
import InlineSvg from "../utils/inline-svg";
import UserBetsTable from "../utils/user-bets-table";
import apiRoutes from "../../api/routes";
import useApiRequest from "../../api/api";
import { formatDaysAgo } from "../utils/date-formatter";

export default function UserBetsComponent() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { makeApiCall } = useApiRequest();
  const [userBets, setUserBets] = useState([]);
  const [userStats, setUserStats] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRacerProfile = async (showLoader = true) => {
    if (showLoader) setIsLoading(true);

    try {
      const response = await makeApiCall(apiRoutes.profile.getUserBets, "GET");
      if (response?.data) {
        setUserStats(response.data.userStats);

        const userBetsData = response.data.bettingDetails.map((data) => ({
          name: data.racerUsername,
          raceName: data.raceName,
          type: "race",
          timestamp: formatDaysAgo(data.winningTime),
          location: data.raceName,
          totalWinning: data.betAmount,
          // odds: data.racerOddFormatted,
          avatar: data.racerPhoto,
          status: data.didWinRace ? "Won" : "Lost",
        }));
        setUserBets(userBetsData);
      }
    } catch (error) {
      console.error("Failed to fetch user bets:", error);
    } finally {
      if (showLoader) setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRacerProfile();
  }, []);
  const navigateToSettings = () => {
    navigate(routes.settings);
  };
  return (
    <Box sx={{ display: "flex", bgcolor: "#171717", height: "100vh" }}>
      {!isMediumScreen && <AccountSidebar />}

      <Box
        display="flex"
        flexDirection="column"
        sx={{
          p: isMediumScreen ? 4 : 10,
          width: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          pt: isMediumScreen ? 5 : 8,
          mb: 7,
          bgcolor: "#121212",
          color: "#fff",
        }}
      >
        <Stack
          onClick={navigateToSettings}
          direction="row"
          sx={{ cursor: "pointer" }}
          alignItems="center"
        >
          {isMediumScreen && (
            <InlineSvg
              sx={{
                cursor: "pointer",
                display: "inline-block",
                width: 20,
                mr: 3,
                pb: 4,
              }}
              url={assetIcons.leftArrow}
            />
          )}
          <Typography
            fontFamily="MontserratBold"
            component="span"
            fontSize={
              isMediumScreen ? fontSizes.heading2 : fontSizes.superHeading5
            }
            textAlign="left"
            sx={{ mb: isMediumScreen ? 4 : 6 }}
          >
            User Bets
          </Typography>
        </Stack>

        {/* Main content */}
        {isLoading ? (
          <Box
            sx={{
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={50} sx={{ color: darkColors.orange }} />
          </Box>
        ) : userBets.length === 0 ? (
          <Box
            sx={{
              height: "70vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              color: "#aaa",
              textAlign: "center",
            }}
          >
            <Typography
              fontFamily="MontserratBold"
              fontSize={20}
              sx={{ color: darkColors.orange, mb: 1 }}
            >
              You've placed no bets yet
            </Typography>
            <Typography fontFamily="Montserrat" fontSize={16}>
              Place a bet in an active race to see it here.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ mt: 0 }}>
            <UserBetsTable userBets={userBets} />
          </Box>
        )}
      </Box>
    </Box>
  );
}
